import { render, staticRenderFns } from "./WaiversPage.vue?vue&type=template&id=33f1e488&scoped=true&"
import script from "./WaiversPage.vue?vue&type=script&lang=js&"
export * from "./WaiversPage.vue?vue&type=script&lang=js&"
import style0 from "./WaiversPage.vue?vue&type=style&index=0&id=33f1e488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f1e488",
  null
  
)

export default component.exports